import { MRT_RowData, MRT_TableOptions } from "material-react-table";

export const bulkTableBaseOptions = <T extends MRT_RowData>(): Partial<MRT_TableOptions<T>> => ({
  layoutMode: "grid",
  enableColumnResizing: true,
  columnResizeMode: "onChange",
  enableColumnActions: false,
  enableColumnFilters: false,
  enablePagination: false,
  enableTopToolbar: false,
  enableBottomToolbar: false,
  enableSorting: true,
  enableStickyHeader: true,
  defaultColumn: { grow: false, size: 160, minSize: 120 },
  muiTableContainerProps: {
    sx: {
      maxHeight: "100%",
      width: "100%",
      overflow: "auto",
      borderRadius: "8px",
      boxShadow: "none",
      border: "1px solid #dbe8f5"
    }
  },
  muiTableHeadCellProps: {
    align: "left",
    sx: {
      backgroundColor: "#f6f8fc !important",
      boxShadow: "none",
      color: "#071f35",
      fontSize: "16px",
      fontWeight: "500",
      border: "none",
      borderBottom: "1px solid #dbe8f5",
      whiteSpace: "nowrap",
      height: "40px",
      textAlign: "left",
      verticalAlign: "middle",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .Mui-TableHeadCell-Content": { alignItems: "center", width: "100%" },
      " .MuiDivider-root": { borderWidth: "1px" },
      minHeight: "40px",
      maxHeight: "40px",
      padding: "8px 20px !important",
      ".Mui-TableHeadCell-ResizeHandle-Wrapper": { cursor: "col-resize", paddingRight: "10px" },
      "& .Mui-TableHeadCell-ResizeHandle-Divider": {
        borderColor: "#e6e8f2 !important",
        opacity: 0,
        borderWidth: "1px !important",
        transition: "opacity 0.15s"
      },
      "&:hover .Mui-TableHeadCell-ResizeHandle-Divider": { opacity: 1 }
    }
  },
  muiTableHeadRowProps: {
    sx: { boxShadow: "none", height: "40px", minHeight: "40px", "& th": { height: "40px", minHeight: "40px" } }
  },
  muiTableBodyCellProps: {
    sx: {
      backgroundColor: "white",
      borderBottom: "1px solid #dbe8f5",
      fontSize: "16px",
      color: "#071f35",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      height: "48px",
      minHeight: "48px",
      maxHeight: "48px",
      padding: "12px 20px !important",
      textAlign: "left",
      "& .MuiTypography-root, & .MuiChip-label": { fontSize: "16px" }
    }
  },
  muiTablePaperProps: {
    sx: {
      boxShadow: "none",
      backgroundColor: "#fff",
      "& [data-can-sort]:not([data-sort]) .MuiTableSortLabel-icon": {
        opacity: "0 !important",
        transition: "opacity 150ms ease-in-out"
      },
      "& [data-can-sort]:hover .MuiTableSortLabel-icon": { opacity: "1 !important" },
      "& [data-sort] .MuiTableSortLabel-icon": { opacity: "1 !important" }
    }
  },
  muiTableBodyRowProps: {
    sx: {
      backgroundColor: "white",
      height: "48px",
      minHeight: "48px",
      transition: "background-color 0.3s ease",
      "& td": { verticalAlign: "middle", height: "48px", minHeight: "48px", transition: "background-color 0.3s ease" },
      "&:hover": { backgroundColor: "#ecf1f8 !important" },
      "&:hover td": { backgroundColor: "#ecf1f8 !important" },
      "&:hover td::after": { backgroundColor: "#ecf1f8" }
    }
  }
});
